import Icon from "@ant-design/icons";
import React from "react";

import { ACIconProps } from "./ACIconWrapper";

export default function NegativeChangeIcon(props: ACIconProps) {
  return <Icon className="ac-icon" component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.46967 7.46967C3.76256 7.17678 4.23744 7.17678 4.53033 7.46967L9.2 12.1393L12.6697 8.66967C12.9626 8.37678 13.4374 8.37678 13.7303 8.66967L19.25 14.1893V11.2C19.25 10.7858 19.5858 10.45 20 10.45C20.4142 10.45 20.75 10.7858 20.75 11.2V16C20.75 16.4142 20.4142 16.75 20 16.75H15.2C14.7858 16.75 14.45 16.4142 14.45 16C14.45 15.5858 14.7858 15.25 15.2 15.25H18.1893L13.2 10.2607L9.73033 13.7303C9.43744 14.0232 8.96256 14.0232 8.66967 13.7303L3.46967 8.53033C3.17678 8.23744 3.17678 7.76256 3.46967 7.46967Z"
        fill="currentColor"
      />
    </svg>
  );
};
